// API Configuration
export const API_BASE_URL = import.meta.env.PROD
  ? 'https://immigration-status-helper-api.kmotte.workers.dev'
  : '/api';
